import { render, staticRenderFns } from "./OfferDetailsPopup.vue?vue&type=template&id=246e0faf&scoped=true&"
import script from "./OfferDetailsPopup.vue?vue&type=script&lang=js&"
export * from "./OfferDetailsPopup.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=246e0faf&prod&scoped=true&lang=css&"
import style1 from "./OfferDetailsPopup.vue?vue&type=style&index=1&id=246e0faf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246e0faf",
  null
  
)

export default component.exports